<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
    <div v-if="visible">
      <v-runtime-template :template="includeYoutubeHtml"/>
    </div>
  </div>
</template>
<script>
import VRuntimeTemplate from 'v-runtime-template'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'WepForum',
  metaInfo () {
  },
  components: {
    VRuntimeTemplate,
    swiper,
    swiperSlide
  },
  data () {
    return {
      includeHtml: '',
      includeYoutubeHtml: '',
      visible: false,
      videoSrc: '',
      options: {
        height: '100%',
        color: '#ccc',
        opacity: 1,
        size: '.6rem',
        distance: '1rem',
        disableFadeOut: true,
        alwaysVisible: true
      },
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 18,
        breakpoints: {
          720: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        },
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        },
        watchSlidesVisibility: true
      },
      swiperOption2: {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          720: {
            slidesPerView: 'auto'
          }
        },
        navigation: {
          nextEl: '.swiper-nav-next',
          prevEl: '.swiper-nav-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        watchSlidesVisibility: true
      },
      forumSwiperSet: {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          872: {
            slidesPerView: 'auto'
          }
        },
        navigation: {
          nextEl: '.swiper-nav-next',
          prevEl: '.swiper-nav-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        watchSlidesVisibility: true
      },
      basePath: this.getStore('mmpAuth').state.basePath
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    },
    includeTempYoutube () {
      return this.includeYoutubeHtml
    }
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    this.getEmptyTemplate('wepMainForum.html')
    this.getTemplateYoutube()
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        this.includeHtml = res
      })
    },
    getTemplateYoutube () {
      let resourceYoutubeUrl = this.getTemplatePath('wepYoutube.html')
      this.$http.loadRes(resourceYoutubeUrl).then( (res) => {
        this.includeYoutubeHtml = res
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/layouts/WepForum.vue